import { StyledLabel } from "./label.style";
import { ILabelProps } from "./label.types";

export function MDSLabel(props: ILabelProps) {
  return <StyledLabel {...props} />;
}
